<template>
  <div class="drag-dom">
    <div style="width: 100%; height: 100%; overflow: hidden" :id="id">
      <!-- 广告 -->
      <transition name="fade">
        <div v-if="videoGgList.length">
          <template v-for="(gg, i) in videoGgList">
            <div
              :key="i"
              :class="`gg-item gg-item-${gg.advertId}-${gg.id} ${
                gg.perpendicularDistance == -1 || gg.horizontalDistance == -1
                  ? 'wz-center'
                  : gg.perpendicularDistance == -2 ||
                    gg.horizontalDistance == -2
                  ? 'wz-b-center'
                  : ''
              }`"
              :style="
                gg.perpendicularDistance >= 0 && gg.horizontalDistance >= 0
                  ? `top:${gg.perpendicularDistance}%;left:${gg.horizontalDistance}%;`
                  : ''
              "
              v-if="gg.showGgitem && gg.pictureH5"
            >
              <div
                class="close-gg"
                v-if="gg.typeFlag == '0'"
                @click="closeGg(gg, 2)"
              >
                <van-image
                  fit="scale-down"
                  :src="require('@/assets/H5/score/close.png')"
                />
              </div>
              <div class="gg-img">
                <van-image
                  object-fit="contain"
                  @click="toLink(gg, 2)"
                  :src="gg.pictureH5 ? gg.pictureH5 : ''"
                />
              </div>
            </div>
          </template>
        </div>
      </transition>
      <!-- 推荐层 -->
      <div
        class="recommend-pop"
        v-if="showRecommend && !isCssFullScreen && !isFullScreen"
      >
        <div class="next-play-tip">
          <!-- 即将播放下一个：{{ nextPlayTime }}s -->
          更多课程
        </div>
        <div class="replay" @click="onRecommendPopReplayBtn">
          <van-icon name="replay" />
          <span>重播</span>
        </div>
        <div class="next-play-list">
          <div
            class="next-play-item"
            v-for="item in recommendList.slice(0, 2)"
            :key="item.columnId"
            @click="clickRecommend(item)"
          >
            <div class="next-play-banner">
              <img
                :src="item.bannerH5 || item.banner"
                alt=""
                class="next-play-banner--img"
              />
            </div>
            <div class="next-play-title">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <!-- 全屏推荐层 -->
      <transition
        name="fade"
        v-if="showRecommend && isCssFullScreen && !isFullScreen"
      >
        <div class="fullscreen-recommend-wrapper">
          <div class="fullscreen-next-play-tip">
            <!-- 即将播放下一个：{{ nextPlayTime }}s -->
            更多课程
          </div>
          <div class="fullscreen-next-play-list">
            <div
              class="fullscreen-next-play-item"
              v-for="item in recommendList"
              :key="item.columnId"
              @click="clickRecommend(item)"
            >
              <div class="fullscreen-next-play-banner">
                <img
                  :src="item.bannerH5 || item.banner"
                  alt=""
                  class="next-play-banner--img"
                />
              </div>
              <div class="fullscreen-next-play-title">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!-- 试看 -->
      <div
        class="shikan mini-shikan"
        v-if="showShiKanFlag && isFreeTime"
        :class="[controlVisible ? 'showControl' : '']"
      >
        <!-- 权限蒙层 -->
        <div
          v-if="videoData.value.videoButton == 1 && applyStatus != 1 && namStr"
        >
          <span class="identification">非认证{{ namStr }}</span
          >可试看{{ isFreeTime }}
        </div>
        <div
          v-else-if="
            videoData.value.videoButton == 1 && applyStatus != 1 && !namStr
          "
        >
          <span class="identification">非认证学员</span>可试看{{ isFreeTime }}
        </div>
        <div v-else-if="videoData.value.videoButton == 2 && applyStatus == 3">
          <span class="identification">游客</span>可试看{{ isFreeTime }}
        </div>
        <div v-else>试看{{ isFreeTime }}</div>
        <!-- {{
          videoData.value.videoButton == 1 && applyStatus != 1 && namStr
            ? "非认证" + namStr + "可试看" + isFreeTime
            : videoData.value.videoButton == 1 && applyStatus != 1 && !namStr
            ? "非认证学员可试看" + isFreeTime
            : videoData.value.videoButton == 2 && applyStatus == 3
            ? "游客可试看" + isFreeTime
            : "免费试看" + isFreeTime
        }} -->
      </div>
      <!-- 成为会员 -->
      <div class="meng login-or-buchong" v-if="showInfo1">
        <div class="text">
          {{
            isFreeTime
              ? `试看结束，成为学员可继续观看`
              : `此内容仅对平台学员开放`
          }}
        </div>
        <div class="btn" @click="sureInfo(1)">
          {{ applyStatus == 3 ? "登录或补充信息" : "前往认证" }}
        </div>
      </div>
      <!-- 指定认证职位 -->
      <div class="meng renzheng" v-if="showInfo2">
        <div class="text">
          {{
            isFreeTime
              ? `试看结束，认证` +
                (namStr ? namStr : "学员") +
                `身份后可继续观看`
              : `此内容仅对认证` + (namStr ? namStr : "学员") + `开放`
          }}
        </div>
        <div class="btn" @click="sureInfo">前往认证</div>
      </div>
      <!-- 非指定职位 重新认证 -->
      <div class="meng renzheng" v-if="showInfo3">
        <div class="text">
          <div>{{ `此内容仅对` + (namStr ? namStr : "") + `开放` }}</div>
          <div class="word mt4">
            {{ `您当前认证职业为` + myTrainerName + `，无权限浏览；` }}
          </div>
          <div class="word">{{ `如您职业已发生变动，请重新认证。` }}</div>
        </div>
        <div class="btn" @click="sureInfo">前往认证</div>
      </div>
      <!-- 认证审核中 -->
      <div class="meng renzheng" v-if="showApplyInfo2">
        <div class="text">
          <div>认证审核中</div>
          <div class="word mt4">此内容仅对认证用户开放</div>
          <div class="word">审核通过后可查看</div>
        </div>
      </div>
      <!-- 试看蒙层 -->
      <div class="meng shikan-over" v-if="showInfo5">
        <div class="title" v-if="isFreeTime">试看结束</div>
        <div class="title" v-else>此为积分兑换课程</div>
        <div class="text">您需要兑换后才可继续观看</div>
      </div>
      <!-- 无试看，需兑换课程 -->
      <!-- <div
        class="meng shikan-over"
        v-if="
          !isCanLookFlag &&
          isCollectFeeStatus &&
          !isFreeTime &&
          !showInfo1 &&
          !showInfo2 &&
          !showInfo3 &&
          !showApplyInfo2
        "
      >
        <div class="title">此为积分兑换课程</div>
        <div class="text">您需要兑换后才可继续观看</div>
      </div> -->
    </div>
    <div id="other"></div>
  </div>
</template>

<script>
import Player from "xgplayer";
import yuanmoMini from "@/utils/rewriteMiniplayer";
import fullScreen from "@/utils/fullScreen";
import {
  defineComponent,
  onMounted,
  watch,
  reactive,
  onBeforeUnmount,
  ref,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { timeToSecond } from "@/utils/dateFormat";
Player.install("yuanmoMini", yuanmoMini);
Player.install("fullScreen", fullScreen);

export default defineComponent({
  name: "Comment-Items",
  props: {
    id: String,
    width: String,
    height: String,
    datas: Object,
    isCanLook: Boolean,
    ggList: Array,
    _showShiKanFlag: Boolean,
    freeTime: Number,
    _showInfo1: Boolean,
    _showInfo2: Boolean,
    _showInfo3: Boolean,
    _showInfo5: Boolean,
    _showApplyInfo2: Boolean,
    phone: String,
    _namStr: String,
    _myTrainerName: String,
    _applyStatus: Number,
    collectFeeStatus: [Boolean, Number],
    // clickSectionTime: Number,
    showRecommend: Boolean,
    nextPlayTime: Number,
    recommendList: Array,
    disableProgress: Boolean,
  },
  setup(props, { emit }) {
    let videoData = reactive({});
    let player = reactive(null);
    let isCanLookFlag = ref(true);
    const route = useRoute();

    let videoGgList = ref([]);

    let showInfo1 = ref(false);
    let showInfo2 = ref(false);
    let showInfo3 = ref(false);
    let showInfo5 = ref(false);
    let showApplyInfo2 = ref(false);
    let namStr = ref("");
    let myTrainerName = ref("");
    let applyStatus = ref(3);

    const controlVisible = ref(true);

    let stop = true;
    // 初始化西瓜视频
    const initPlayer = () => {
      const progressDot = props.datas.chapterList?.map((item) => ({
        time: timeToSecond(item.timeNode),
        // text: item.chapterName || "",
      }));
      if (player) {
        player.poster = videoData.value.banner;
        player.removeAllProgressDot();
        if (!isCanLookFlag.value) {
          player.pause();
          return false;
        }
        player.start(videoData.value.content);
        player.once("canplay", () => {
          player.currentTime = videoData.value.userViewTime;
          progressDot?.forEach((item) => {
            player.addProgressDot(item.time, item.text);
          });
        });
      } else {
        player = new Player({
          id: props.id,
          height: props.height,
          width: props.width,
          url: videoData.value.content,
          poster: videoData.value.banner,
          lastPlayTime: videoData.value.userViewTime,
          lastPlayTimeHideDelay: 0,
          playsinline: true,
          autoplay: true,
          // miniplayer: true,
          customFullscreen: true, // 自定义插件属性
          // ignores: ["fullscreen"], // 只有ios手机，全屏的时候会被系统播放器接管，无法显示广告
          // cssFullscreen: true,
          disableProgress: props.disableProgress, //禁止拖动
          miniplayerConfig: {
            bottom: 200,
            right: 16,
            width: 160,
            height: 90,
          },
          progressDot,
        });

        player.on("play", () => {
          if (!isCanLookFlag.value) {
            player.pause();
            return false;
          }
          emit("play", player);
          stop = false;
        });
        player.on("timeupdate", () => {
          emit("timeupdate", player);
        });
        player.on("pause", () => {
          emit("pause", player);
          stop = true;
        });
        player.on("ended", () => {
          emit("ended", player);
          stop = true;
          if (hasClass(player.root, "xgplayer-miniplayer-active")) {
            player.closeYMMini();
          }
        });
        player.on("replayBtnClick", () => {
          emit("replay");
        });
        player.on("requestCustomFullscreen", () => {
          isCssFullScreen.value = true;
          emit("showNavarBar", false);
        });
        player.on("exitCustomFullscreen", () => {
          isCssFullScreen.value = false;
          emit("showNavarBar", true);
        });
        player.on("requestFullscreen", () => {
          isFullScreen.value = true;
        });
        player.on("exitFullscreen", () => {
          isFullScreen.value = false;
        });

        // 控制栏展示
        player.on("controlShow", () => {
          controlVisible.value = true;
        });
        // 控制栏隐藏
        player.on("controlHide", () => {
          controlVisible.value = false;
        });
      }
    };
    //更新视频章节的时间
    watch(
      () => props.datas.clickSectionId,
      (newValue) => {
        if (newValue) {
          player.currentTime = props.datas.userViewTime;
        }
      }
    );
    function handleScroll() {
      window.addEventListener("scroll", () => {
        let y = window.scrollY;
        if (y > 40) {
          emit("navbar", "showTitle");
        } else {
          emit("navbar", "hideTitle");
        }
        if (!player || !player.root) {
          return;
        }
        if (y > 260 && !stop) {
          if (!hasClass(player.root, "xgplayer-miniplayer-active")) {
            // player.getMiniplayer();
            player.openYMMini();
          }
        } else {
          player.closeYMMini();
        }
      });
    }
    function hasClass(el, className) {
      if (!el) {
        return false;
      }

      if (el.classList) {
        return Array.prototype.some.call(
          el.classList,
          (item) => item === className
        );
      } else if (el.className) {
        return !!el.className.match(
          new RegExp("(\\s|^)" + className + "(\\s|$)")
        );
      } else {
        return false;
      }
    }
    const toLink = async (item) => {
      emit("toGg", item);
    };

    // 关闭广告
    const closeGg = (item) => {
      emit("closeGg", item);
    };

    const getTime = (time) => {
      if (time) {
        // 转换为式分秒
        let h = parseInt((time / 60 / 60) % 24);
        let m = parseInt((time / 60) % 60);
        let s = parseInt(time % 60);
        // 作为返回值返回
        if (h > 0) {
          return h + "时" + m + "分" + (s > 0 ? s + "秒" : "钟");
        } else {
          return m + "分" + (s > 0 ? s + "秒" : "钟");
        }
      } else {
        return "";
      }
    };

    const router = useRouter();
    let thisQuery = router.currentRoute.value.query;
    thisQuery._path_name = router.currentRoute.value.name;
    const sureInfo = (id) => {
      if (!userPhone.value) {
        //游客 -> 去绑定手机号成为会员
        emit("toBindPhone", 1);
      } else {
        if (id && id == 1 && applyStatus.value == 3) {
          emit("tosureInfo", 1);
        } else {
          emit("tosureInfo", "");
        }
      }
    };

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", () => {});
    });

    watch(
      () => props.datas.id,
      () => {
        if (props.datas.id) {
          videoData.value = props.datas;
          isCanLookFlag.value = true;
          initPlayer();
          if (!isCanLookFlag.value) {
            player.pause();
          }
        } else {
          if (player) {
            player.pause();
          }
        }
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    watch(
      () => props.ggList,
      () => {
        videoGgList.value = props.ggList.length ? props.ggList : [];
      },
      {
        deep: true, // 深度监听的参数
      }
    );

    watch(
      () => props.isCanLook,
      (val) => {
        isCanLookFlag.value = val;
        if (!isCanLookFlag.value) {
          player.pause();
          return;
        }
        if (player) {
          player.play();
        } else {
          initPlayer();
        }
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    watch(
      () => props._showInfo1,
      (val) => {
        showInfo1.value = val;
        if (val) {
          player.pause();
        }
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    watch(
      () => props._namStr,
      (val) => {
        namStr.value = val;
        if (val) {
          // player.pause();
        }
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    watch(
      () => props._showInfo2,
      (val) => {
        showInfo2.value = val;
        namStr.value = props._namStr;
        if (val) {
          player.pause();
        }
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    watch(
      () => props._showInfo3,
      (val) => {
        showInfo3.value = val;
        namStr.value = props._namStr;
        myTrainerName.value = props._myTrainerName;
        if (val) {
          player.pause();
        }
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    watch(
      () => props._showInfo5,
      (val) => {
        showInfo5.value = val;
        if (val) {
          player.pause();
        }
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    watch(
      () => props._showApplyInfo2,
      (val) => {
        showApplyInfo2.value = val;
        if (val) {
          player.pause();
        }
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    watch(
      () => props._applyStatus,
      (val) => {
        applyStatus.value = val;
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    watch(
      () => props._showShiKanFlag,
      (val) => {
        showShiKanFlag.value = val;
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    watch(
      () => props.freeTime,
      (val) => {
        isFreeTime.value = getTime(val);
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    watch(
      () => props.collectFeeStatus,
      (val) => {
        isCollectFeeStatus.value = val;
      },
      {
        deep: true, // 深度监听的参数
      }
    );
    let showShiKanFlag = ref(false);
    let isFreeTime = ref("");
    let isCollectFeeStatus = ref("");
    let userPhone = ref("");
    const store = useStore();
    onMounted(() => {
      videoData.value = props.datas;
      let userinfo = store.state.user.userinfo;
      userPhone.value = userinfo && userinfo.phone ? userinfo.phone : "";
      showShiKanFlag.value = props._showShiKanFlag;
      isFreeTime.value = getTime(props.freeTime);
      isCollectFeeStatus.value = props.collectFeeStatus;
      handleScroll();
    });
    // const showRecommend = ref(true);
    const isCssFullScreen = ref(false); // css全屏
    const isFullScreen = ref(false);
    const clickRecommend = (item) => {
      emit("playRecommend", item.columnId);
    };
    const onRecommendPopReplayBtn = () => {
      emit("replay", player);
    };
    return {
      videoData,
      videoGgList,
      toLink,
      closeGg,
      isCanLookFlag,
      showShiKanFlag,
      isFreeTime,
      isCollectFeeStatus,
      showInfo1,
      showInfo2,
      showInfo3,
      showInfo5,
      showApplyInfo2,
      sureInfo,
      userPhone,
      namStr,
      myTrainerName,
      applyStatus,
      isCssFullScreen,
      isFullScreen,
      clickRecommend,
      controlVisible,
      onRecommendPopReplayBtn,
    };
  },
});
</script>
<style lang="less" scoped>
// .drag-dom {
//   /deep/ .xgplayer-inactive .xgplayer-miniplayer-drag {
//     display: block !important;
//     height: 100% !important;
//   }
// }
/deep/ .xgplayer-fullscreen {
  display: none;
}
.drag-dom {
  height: 100%;
  // transform-style: preserve-3d;

  /deep/ video {
    // position: relative;
    // z-index: 10;
  }
  /deep/ .xgplayer-controls {
    // z-index: 11;
    transform: translateZ(100px);
  }
  /deep/ .xgplayer-start {
    transform: translateZ(100px);
  }
  /deep/ .xgplayer-replay {
    transform: translateZ(100px);
  }
  /deep/ .xgplayer-miniplayer-active#xgPlayer {
    width: 160px !important;
    height: 90px !important;
    // position: absolute;
    // right: 16px;
    // bottom: 200px;
    margin-top: 530px;
    margin-left: 200px;
    // position: absolute;
    // right: 0;
    // bottom: 200px;
  }
  /deep/.xgplayer-skin-default.xgplayer-inactive .xgplayer-miniplayer-drag {
    display: block;
  }
  // /deep/.xgplayer-start {
  //   display: none;
  // }
}

.gg-item {
  position: absolute;
  left: 0%;
  overflow: hidden;
  max-width: 375px;
  max-height: 212px;
  z-index: 990;
  // 提升层级
  transform: translateZ(100px);
  &.wz-center {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
  }
  &.wz-b-center {
    bottom: 0 !important;
    left: 50% !important;
    transform: translateX(-50%);
  }
  .close-gg {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 1;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.15);
    .van-image {
      width: 18px;
      height: 18px;
    }
  }
  .gg-img {
    font-size: 0;
    overflow: hidden;
    /deep/ .van-image {
      font-size: 0;
      overflow: hidden;
    }
  }
}

// 视频权限蒙层
.meng {
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  &.login-or-buchong,
  &.renzheng {
    .text {
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;
      line-height: 22px;
      text-align: center;
      max-width: 80%;
      margin: 64px auto 11px auto;
      .mt4 {
        margin-top: 4px;
      }
      .word {
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
      }
    }
    .btn {
      width: 160px;
      height: 40px;
      background: #0f3cc6;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      margin: 0 auto;
    }
  }
}
.shikan {
  background: rgba(0, 0, 0, 0.7);
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  position: absolute;
  bottom: 10px;
  right: 10px;
  padding: 8px 12px;
  box-sizing: border-box;
  border-radius: 22px;
  transform: translateZ(100px);
  .identification {
    color: #ffa622;
  }

  &.showControl {
    bottom: 48px;
  }
}
::v-deep(.xgplayer-miniplayer-active) {
  .mini-shikan {
    padding: 4px;
    font-size: 10px;
    transform: scale(0.83333);
    transform-origin: 0 0;
  }
}
.shikan-over {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  .title {
    height: 22px;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    margin-bottom: 4px;
    // max-width: 80%;
    // margin: 64px auto 4px auto;
  }
  .text {
    height: 20px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
  }
}

// 修改播放器样式
::v-deep(.xgplayer-rotate-fullscreen) {
  .xgplayer-icon-exitfull {
    display: block !important;
  }
  .xgplayer-icon-requestfull {
    display: none !important;
  }
}

::v-deep(.xgplayer) {
  // z-index: 8;
  z-index: 9;

  .xgplayer-cssfullscreen {
    padding-left: 10px;
  }
  // 修改时间提示的样式
  .xgplayer-progress-played {
    background-image: none;
    background-color: #fff;
  }
  .xgplayer-progress-dot {
    width: 4px;
    height: 4px;
    top: -1px;
    // transform: translateY(-50%);
  }
  .xgplayer-progress-outer {
    height: 2px;
    line-height: 2px;
    background: rgba(255, 255, 255, 0.3);
  }
  .xgplayer-progress:hover .xgplayer-progress-outer {
    height: 2px !important;
  }
  .xgplayer-progress:hover .xgplayer-progress-dot {
    height: 4px;
  }
  .xgplayer-progress-btn {
    width: 10px;
    height: 10px;
    box-shadow: none;
    background: url("@/assets/H5/play/playerdot.png") no-repeat;
    background-size: contain;
    top: -4px;
  }

  .xgplayer-progress:hover
    .xgplayer-skin-default.xgplayer-mobile
    .xgplayer-progress-btn {
    top: -4px !important;
  }
}
.recommend-pop {
  box-sizing: border-box;
  position: absolute;
  z-index: 106; //重播的z-index: 105;
  transform: translateZ(101px);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  padding: 16px 30px 34px;
}
.replay {
  position: absolute;
  width: 60px;
  height: 60px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 8px;
  font-size: 14px;
  .van-icon {
    font-size: 14px;
    font-family: "vant-icon" !important;
  }
}
.next-play-tip {
  text-align: center;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #fff;
  line-height: 20px;
  margin-bottom: 26px;
}
.next-play-list {
  display: flex;
  justify-content: space-between;
  column-gap: 12px;
}
.next-play-item {
  width: 152px;
}
.next-play-banner {
  width: 152px;
  height: 85px;
  background: #d8d8d8;
  border-radius: 7px;
  overflow: hidden;
}
.next-play-banner--img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.next-play-title {
  width: 100%;
  margin-top: 10px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #fff;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
// 横向推荐
.fullscreen-recommend-wrapper {
  box-sizing: border-box;
  position: absolute;
  right: 0;
  top: 0;
  width: 274px;
  height: 375px;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.65) 38%,
    #000000 100%
  );
  opacity: 0.8;
  z-index: 106;
  padding: 32px 24px 24px 40px;
  color: #fff;
  overflow: auto;
}
.fullscreen-next-play-tip {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 22px;
  margin-bottom: 16px;
}
.fullscreen-next-play-list .fullscreen-next-play-item:last-child {
  border-bottom: none;
  margin-bottom: 0px;
}
.fullscreen-next-play-item {
  width: 210px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 10px;
}
.fullscreen-next-play-banner {
  width: 149px;
  height: 84px;
  border-radius: 4px;
  overflow: hidden;
  background: #d8d8d8;
}
.fullscreen-next-play-title {
  width: 210px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
